// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZfsU","index":"styles_index__11nPY"};